import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { charcoalGrey, universalStyles, white } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  pageList: {
    marginBottom: 30,
  },
  whiteText: {
    color: white,
  },
  grayBox: {
    backgroundColor: charcoalGrey,
    marginTop: 32,
    marginBottom: 50,
    paddingTop: 20,
    paddingBottom: 50,
    paddingLeft: 43,
    paddingRight: 89,
  },
  header: {
    color: white,
    fontSize: 20,
    fontWeight: 900,
  },
}));

const AcquisitionPage01 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6">
        This training is designed to help technologists understand the process of dosing and administration of Axumin
        and optimize image acquisition protocols.
      </Typography>
      <div className={classes.grayBox}>
        <Typography className={classes.header}>The Image Acquisition Training contains the following:</Typography>
        <ul className={classNames(classes.list, classes.whiteText, classes.pageList)}>
          <li>Steps needed to effectively capture optimal quality images</li>
          <li>Learning check questions to ensure understanding of all the training materials</li>
          <ul className={classNames(classes.nestedList, classes.whiteText)}>
            <li>
              These are ungraded practice questions intended to improve technologist learning and keep you engaged
              throughout the training
            </li>
          </ul>
          <li>
            Clinical case studies, which follow patients from clinical presentation, imaging (including maximum
            intensity projection, MIP), and, finally, image findings
          </li>
        </ul>
        <Typography className={classes.header}>
          We encourage all participants to set aside 90 minutes to complete this training. If you are interrupted or
          logged out, you will be redirected to the last web-page you reviewed upon returning to this training track.
          <br />
          <br />
          <i>To gain access to additional materials, please be sure to fully complete this training.</i>
        </Typography>
      </div>
    </>
  );
};

export default AcquisitionPage01;
